export const TEST_ID_MOBILE_SUMMARY_FLIGHTS_DAYS_DIFF_TO =
  'mobile-summary-flights-days-diff-to';

export const TEST_ID_MOBILE_SUMMARY_FLIGHTS_DAYS_DIFF_BACK =
  'mobile-summary-flights-days-diff-back';
